import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import {
  Button,
  Dimmer,
  Dropdown,
  Grid,
  Input,
  Label,
  Loader,
  Segment,
} from 'semantic-ui-react';

import { flashMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import EditImage from '../../components/EditImage';

export default class UploadBookingPaymentPictureForm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    fileType: PropTypes.string,
    btnText: PropTypes.string,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultProps = {
    btnText: 'Images',
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: props.loading || false,
      uploads: [],
      tags: [],
      degrees: [],
      names: [],
      options: [],
      hasChanges: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ loading: nextProps.loading || false });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  submit(url, opts = {}) {
    const { store } = this.context;
    return this.setLoading(true)
      .then(() => store.dispatch(fetchM(url, opts)))
      .then(res => res.json())
      .then(result => this.setLoading(false)
        .then(() => result))
      .catch(err => this.setLoading(false)
        .then(() => Promise.reject(err)));
  }
  resetFiles() {
    // temporary fix for upload modal not closing
    this.setState({
      uploads: [],
      tags: [],
      names: [],
      degrees: [],
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.uploads.length > 0) {
      const formData = new FormData(this.bppForm);
      this.state.uploads.forEach((upload, idx) => {
        formData.append(`files_${idx}`, upload.file);
        formData.append(`tags_${idx}`, this.state.tags[idx]);
        formData.append(`degrees_${idx}`, this.state.degrees[idx] || 0);
        formData.append(`names_${idx}`, this.state.names[idx]);
      });
      formData.append('total_attached', this.state.uploads.length || 0);
      if (this.props.onSubmit) {
        this.props.onSubmit(event, formData);
      }
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        if (this.props.onChange) {
          this.props.onChange(true);
        }
      });
    }
  }
  handleOnChange = () => {
    const { store } = this.context;
    const { fileType } = this.props;
    const fileExtLength = (fileType === 'docx' ? 5 : 4);
    const files = Array.prototype.slice.call(this.uploadFiles.files);
    this.uploadFiles.value = null;
    if (window.FileReader) {
      files.forEach((file) => {
        if ((!fileType && file.type.match('image.*')) ||
        (fileType && fileType === 'attachment' && (file.type.match('image.*') || file.type.match('application/pdf')) && file.size < 10485760) ||
        (fileType === 'docx' && file.type.match(this.allowedFileTypes()) && file.size < 10485760)) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const { uploads, tags, names } = this.state;
            const upload = {
              file,
              name: file.name.substring(0, file.name.length - fileExtLength),
              src: reader.result,
            };
            uploads.push(upload);
            tags.push([]);
            names.push(upload.name);
            this.setState({
              uploads,
              tags,
              names,
            }, () => {
              this.handleCheckChanges();
            });
          };
          reader.readAsDataURL(file);
        } else if
        ((fileType && fileType === 'attachment' && (file.type.match('image.*') || file.type.match('application/pdf')) && file.size > 10485760)
        || (fileType && fileType === 'docx' && file.size > 10485760)
        ){
          store.dispatch(flashMessage({
            header: 'Maximum file size exceeded',
            message: 'Please ensure file is less than 10MB.',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
        } else if (fileType && fileType === 'attachment' && !(file.type.match('image.*') && !file.type.match('application/pdf'))) {
          store.dispatch(flashMessage({
            header: 'Wrong file format',
            message: 'Only JPG, JPEG, PNG and PDF files are allowed.',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
        } else {
          store.dispatch(flashMessage({
            header: 'Wrong file format',
            message: 'Only JPG, JPEG and PNG files are allowed.',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000,
          }));
        }
      });
    }
  }
  handleRemove = (event, idx) => {
    event.preventDefault();
    const { uploads, tags, degrees, names } = this.state;
    uploads.splice(idx, 1);
    degrees.splice(idx, 1);
    tags.splice(idx, 1);
    names.splice(idx, 1);
    this.setState({ uploads, degrees, tags, names });
  }
  handleAddFile = (event) => {
    event.preventDefault();
    this.uploadFiles.click();
  }
  handleTagsChange = (e, value, idx) => {
    const { tags } = this.state;
    tags[idx] = value;
    this.setState({ tags });
  }
  handleInputChange = (e, value, idx) => {
    const { names } = this.state;
    names[idx] = value;
    this.setState({ names });
  }
  handleAddition = (e, { value }) => {
    this.setState({
      options: [{ text: value, value }, ...this.state.options],
    });
  }
  handleRotate = (direction, idx) => {
    const { degrees } = this.state;
    if (!degrees[idx]) {
      degrees[idx] = 0;
    }
    const increment = direction === 'right' ? 1 : -1;
    degrees[idx] += 90 * increment;
    if (degrees[idx] >= 360) {
      degrees[idx] = 0;
    }
    if (degrees[idx] < 0) {
      degrees[idx] = 270;
    }
    this.setState({ degrees });
  }
  allowedFileTypes = () => {
    const { fileType } = this.props;
    if (fileType === 'attachment') {
      return 'image/gif, image/jpeg, image/png, application/pdf';
    }
    if (fileType === 'docx') {
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }
    return 'image/gif, image/jpeg, image/png';
  }
  render() {
    const { fileType } = this.props;
    return (
      <form
        encType="multipart/form-data"
        onSubmit={this.handleSubmit}
        name="uploadBookingPaymentPictures"
        ref={(ref) => { this.bppForm = ref; }}
      >
        <input
          ref={(ref) => { this.uploadFiles = ref; }}
          type="file"
          onChange={this.handleOnChange}
          accept={this.allowedFileTypes()}
          multiple
          style={{ display: 'none' }}
        />
        <Grid verticalAlign="middle" stackable>
          <Grid.Row columns="equal">
            <Grid.Column only="computer" />
            <Grid.Column>
              <Grid verticalAlign="middle" columns="equal">
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    primary
                    icon="add"
                    content={this.props.btnText}
                    onClick={this.handleAddFile}
                    disabled={this.state.loading}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    compact
                    onClick={this.handleSubmit}
                    positive
                    content={i18next.t('Upload', { ns: 'screens' })} icon="cloud upload"
                    loading={this.state.loading}
                    disabled={this.state.uploads.length < 1 || this.state.loading}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid stackable doubling columns={1}>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader indeterminate inline="centered">{i18next.t('Uploading', { ns: 'translation' })}</Loader>
          </Dimmer>
          {
            this.state.uploads.length > 0 ?
              this.state.uploads.map((upload, idx) => (
                <Grid.Column key={idx}>
                  <Segment.Group>
                    <Segment secondary>
                      <EditImage
                        src={upload.src}
                        degree={this.state.degrees[idx] || 0}
                      />
                      <Label
                        as="a"
                        corner
                        color="red"
                        icon="delete"
                        disabled={this.state.loading}
                        onClick={e => this.handleRemove(e, idx)}
                      />
                    </Segment>
                    <Segment padded>
                      <Grid columns={1}>
                        {
                          fileType && ((fileType === 'attachment' && upload.file.type === 'application/pdf') || fileType === 'docx') ? null : (
                            <Grid.Column>
                              <Label
                                as="a"
                                attached="top left"
                                icon={{ name: 'repeat', flipped: 'horizontally' }}
                                disabled={this.state.loading}
                                onClick={() => this.handleRotate('left', idx)}
                              />
                              <Label
                                as="a"
                                attached="top right"
                                icon="repeat"
                                disabled={this.state.loading}
                                onClick={() => this.handleRotate('right', idx)}
                              />
                            </Grid.Column>
                          )
                        }
                        <Grid.Column>
                          <Input
                            placeholder="Name"
                            fluid
                            value={this.state.names[idx]}
                            disabled={this.state.loading}
                            onChange={(e, { value }) => this.handleInputChange(e, value, idx)}
                            readOnly={fileType === 'docx'}
                          />
                          {fileType !== 'docx' &&
                            <Dropdown
                              options={this.state.options}
                              placeholder={i18next.t('Add tags', { ns: 'translation' })}
                              search
                              selection
                              fluid
                              multiple
                              allowAdditions
                              noResultsMessage={i18next.t('Add tags', { ns: 'translation' })}
                              value={this.state.tags[idx]}
                              onAddItem={this.handleAddition}
                              disabled={this.state.loading}
                              onChange={(e, { value }) => this.handleTagsChange(e, value, idx)}
                            />
                          }
                        </Grid.Column>
                      </Grid>
                    </Segment>
                  </Segment.Group>
                </Grid.Column>
              ))
            : null
          }
        </Grid>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BookingPaymentPictures/Form.jsx